<div
  class="wrapper"
  [ngClass]="{ 'p-5 align-items-center flex-column justify-content-center': isMobileOrTabletDevice }"
>
  <img class="mb-5 mobile-logo" *ngIf="isMobileOrTabletDevice" src="/assets/images/foxydeals_logo.png" />
  <div class="left-side" *ngIf="('' | isMobileDevice) === false"
    ><img class="mb-5 desktop-logo" src="/assets/images/foxydeals_logo.png" /><img
      style="width: 100%; height: 100%"
      src="/assets/images/login_image.jpg"
  /></div>
  <div class="right-side" [ngClass]="{ 'card p-3': isMobileOrTabletDevice }">
    <h1>{{ titleTranslateKey | transloco }}</h1>
    <ng-content></ng-content>
  </div>
</div>

<div class="layout-footer flex align-items-center p-1 pr-4 pl-4 shadow-2 w-100" *ngIf="isMobileOrTabletDevice">
  <img class="footer-logo" src="/assets/images/foxydeals_logo.png" style="height: 2.25rem" />
  <p class="copyright m-auto">© {{ today | date: 'yyyy' }} FOXYDEALS</p>
  <ng-container *ngIf="!('' | isMobile)">
    <a class="mr-5" href="https://foxydeals.at">Zu Foxydeals wechseln</a>
    <a class="mr-5" href="https://ezhovamutasson.com">Untertützung</a>
  </ng-container>
</div>

